import EmptyPage from '../../../components/empty-page/emptyPage';
import CommonTable from '../../../components/reusable-ui-components/commonTable/CommonTable';
import { getTotalSeatCount } from '../../../utils/getTotalSeatCount';

const SupBookingGu = ({ bookingData, orgId }) => {
    const columns = [
        {
            label: 'Guide Name',
            accessor: 'guTourId',
            render: (val) => val?.title || 'N/A'
        },
        ...(!orgId
            ? [
                  {
                      label: 'Organizer',
                      accessor: 'organizerId',
                      render: (val) => val?.companyName || 'N/A'
                  }
              ]
            : []),

        {
            label: 'Name',
            accessor: 'userDetails',
            render: (val) => val?.[0]?.name || 'N/A'
        },

        {
            label: 'Date',
            accessor: 'startDate',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Time Slot',
            accessor: 'timeSlots',
            render: (val) => {
                if (!val) return '-';
                return `${val.startTime} - ${val.endTime}`;
            }
        },
        {
            label: 'Booked On',
            accessor: 'createdAt',
            render: (val) => new Date(val).toLocaleDateString()
        },
        {
            label: 'Payment',
            accessor: 'amountPaid',
            render: (val, row) => {
                const isReserved = val?.isReserved;
                const isInstallment = val?.isInstallment;

                if (!isReserved && !isInstallment) {
                    return <div style={{ textAlign: 'center' }}>Full payment<br />Paid: ₹{Number(val?.paid) || 0}</div>;
                }

                const total = Number(val?.total) || 0;
                const paid = Number(val?.paid) || 0;
                let balance = 0;

                if (isReserved) {
                    const reserve = Number(val?.reserve) || 0;
                    const totalSeats = Number(row?.totalSeats) || 0;

                    balance = total - reserve * totalSeats;
                } else if (isInstallment) {
                    const installmentAmount = Number(val?.installments?.[0]?.amount) || 0;

                    balance = total - installmentAmount;
                }

                return (
                    <div
                        style={{
                            color: 'red',
                            textAlign: 'center',
                            whiteSpace: 'pre-line',
                            verticalAlign: 'middle'
                        }}
                    >
                        {`${isReserved ? 'Reserved' : 'Installment'}\n${isReserved ? `(₹${Number(val?.reserve) || 0}/seat)` : `(₹${Number(val?.installments?.[0]?.amount) || 0})`}
Total: ₹${total}
Paid: ₹${paid}
Balance: ₹${balance}`}
                    </div>
                );
            }
        },
        {
            label: 'Total Seats',
            accessor: 'totalSeats',
            render: (val, row) => {
                if (Array.isArray(val)) {
                    return row?.seatsCount ?? 0;
                }

                return val ?? row?.seatsCount ?? 0;
            }
        },
        {
            label: 'Booked Via',
            accessor: 'bookedVia'
        },
        {
            label: 'People',
            accessor: 'userDetails',
            render: (val) => val?.length || 0
        },
        {
            label: 'Action',
            accessor: 'action',
            render: (_, row) => {
                // condition example
                // if (guStatus === 'Upcoming') {
                //     return row?.guStatus === 'Cancelled' ? (
                //         <span style={{ color: 'red', fontWeight: '600' }}>{row?.guStatus}</span>
                //     ) : (
                //         <span
                //             className='cancelTrip-btn'
                //             onClick={() => {
                //                 setShowModal(true);
                //                 setRowId(row._id);
                //             }}
                //         >
                //             Cancel
                //         </span>
                //     );
                // }

                return row.guStatus !== 'Cancelled' ? (
                    <span>{row?.guStatus}</span>
                ) : (
                    <span style={{ color: 'red', fontWeight: '600' }}>{row?.guStatus}</span>
                );
            }
        }
    ];
    return (
        <div>
            {bookingData && bookingData.length !== 0 ? (
                <CommonTable data={bookingData} columns={columns} />
            ) : (
                <EmptyPage />
            )}
        </div>
    );
};

export default SupBookingGu;
